import React, { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import Table from "../../components/tables/Table";
import Button from "../../components/Button";
import {
  CheckCircleIcon,
  PencilSquareIcon,
  XCircleIcon,
} from "@heroicons/react/24/solid";
import SelectInput from "../../components/SelectInput";
import TextInput from "../../components/TextInput";
import DateInput from "../../components/DateInput";

import ButtonCancel from "../../components/ButtonCancel";

import { updateFees } from "../../actions/Utilities/Fees";
import Swal from "sweetalert2";
import ConfirmBoxModal from "../../components/ConfirmBoxModal";
import { permissionsSelector } from "../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../PermissionsConstants";

const PolicyFeeTable = ({
  policyFeeData,
  isLoading,
  stateOptions,
  carrierOptions,
  feeLevelOptions,
  selectedRows,
  handleBulkDelete,
  setOpenModal,
  setIsBulkSelected,
  selectableRows,
  handleSelectedRowsChange,
  refetch,
  clearSelectedRows,
  feeTypeData,
  policyTermOptions,
  hasAccess,
}) => {
  const queryClient = useQueryClient();

  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState([]);
  const [showdata, setShowData] = useState([]);
  const [selectedCarrier, setSelectedCarrier] = useState([]);
  const [selectedState, setSelectedState] = useState([]);

  const [selectedFeeLevel, setSelectedFeeLevel] = useState([]);
  const [selectedPolicyTerm, setSelectedPolicyTerm] = useState([]);

  const [effectiveDate, setEffectiveDate] = useState("");
  const [expirationDate, setExpirationDate] = useState("");
  const [changed, setChanged] = useState(false);
  const [saveModal, setSaveModal] = useState(false);
  const userPermissions = useRecoilValue(permissionsSelector);
  const viewPermission = PERMISSIONS.permission_policyfee_view;
  const addPermission = PERMISSIONS.permission_policyfee_add;
  const editPermission = PERMISSIONS.permission_policyfee_edit;
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const policyTypeFormat = {
    commissionablePremiumId: 0,
    carrierId: 0,
    carrierName: "",
    state: "",
    effectiveDate: null,
    expirationDate: null,
    policyTerm: 0,
    feeType: "",
    feeAmount: 0,
    feeLevel: "",
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
  };
  const [updatedPolicyTypeData, setUpdatedPolicyTypeData] = useState([
    policyTypeFormat,
  ]);

  function getUnique(arr, index) {
    const unique = arr
      .map((e) => e[index])

      // store the keys of the unique objects
      .map((e, i, final) => final.indexOf(e) === i && i)

      // eliminate the dead keys & store unique objects
      .filter((e) => arr[e])
      .map((e) => arr[e]);

    return unique;
  }

  useEffect(() => {
    const updatedData = policyFeeData.map((item) => {
      item.editRow = false;
      return { ...item };
    });
    setShowData(updatedData);
  }, []);
  const [editDataDetails, setEditDataDetails] = useState([]);
  const handleEditModal = (row) => {
    setSaveModal(true);
    setEditDataDetails(row);
  };
  const handleEdit = (row) => {
    const editData = policyFeeData.map((item) => {
      if (
        item.commissionablePremiumId === row.commissionablePremiumId &&
        (item.carrierName === row.carrierName) & (item.state === row.state)
      ) {
        item.editRow = true;
      } else {
        item.editRow = false;
      }
      return { ...item };
    });
    setSelectedPolicyTerm(
      policyTermOptions.filter((item) => item.value === row.policyTerm)
    );
    setSelectedCarrier(
      carrierOptions.filter((item) => item.label === row.carrierName)
    );
    setSelectedState(stateOptions.filter((item) => item.label === row.state));
    setEditMode(true);

    setSelectedFeeLevel(
      feeLevelOptions.filter((item) => item.label === row.feeLevel)
    );

    if (effectiveDate !== "") {
      setEffectiveDate(row.effectiveDate && row.effectiveDate.slice(0, 10));
    }

    if (expirationDate !== "") {
      setExpirationDate(row.expirationDate && row.expirationDate.slice(0, 10));
    }

    setEditData(editData);
    updatedPolicyTypeData[0].commissionablePremiumId =
      row.commissionablePremiumId;
    updatedPolicyTypeData[0].effectiveDate = row.effectiveDate;
    updatedPolicyTypeData[0].expirationDate = row.expirationDate;
    updatedPolicyTypeData[0].policyTerm = row.policyTerm;
    updatedPolicyTypeData[0].feeLevel = row.feeLevel;
    updatedPolicyTypeData[0].feeType = row.feeType;
    updatedPolicyTypeData[0].feeAmount = row.feeAmount;
    updatedPolicyTypeData[0].createdBy = row.createdBy;
    updatedPolicyTypeData[0].createdOn = row.createdOn;
    updatedPolicyTypeData[0].updatedBy = localStorage.getItem("userName");
    updatedPolicyTypeData[0].updatedOn = new Date().toISOString();
    setChanged(false);
  };

  const CollapseAll = () => {
    const updatedData = policyFeeData.map((item) => {
      item.expandRow = false;
      item.editRow = false;

      return { ...item };
    });
    setShowData(updatedData);
  };

  const handlCancel = (row) => {
    setEditMode(false);
    CollapseAll();
  };

  const handleSave = (row) => {
    if (changed) {
      updatedPolicyTypeData[0].carrierId = selectedCarrier[0].value;
      updatedPolicyTypeData[0].carrierName = selectedCarrier[0].label;
      updatedPolicyTypeData[0].state = selectedState[0].label;
      if (
        updatedPolicyTypeData[0].effectiveDate !== "" &&
        feeTypeData.filter((x) => x.value === updatedPolicyTypeData[0].feeType)
          .length > 0 &&
        updatedPolicyTypeData[0].feeAmount !== ""
      ) {
        updateFees(updatedPolicyTypeData).then(() => {
          queryClient.invalidateQueries(["Fees"]);
          queryClient.invalidateQueries(["CarrierOptions"]);
          queryClient.invalidateQueries(["States"]);
          Toast.fire("Success", "Fees Updated Successfully", "success");
          setEditMode(false);
          setSaveModal(false);

          CollapseAll();
        });
      } else {
        Toast.fire("Saving Failed", "All fields must be filled!", "error");
      }
    } else {
      Toast.fire("Saving Failed", "No Changes have been made", "warning");
    }
  };

  const handleEditPolicyType = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    if (SourceType === "EditPolicyType") {
      if (fieldName === "feeType") {
        updatedPolicyTypeData[0].feeType =
          inputvalue.value !== undefined ? inputvalue.value : "";
      }
      if (fieldName === "feeAmount") {
        updatedPolicyTypeData[0].feeAmount = inputvalue;
      }
      if (fieldName === "policyTerm") {
        updatedPolicyTypeData[0].policyTerm =
          inputvalue.value !== undefined ? inputvalue.value : "0";
      }
      if (fieldName === "feeLevel") {
        updatedPolicyTypeData[0].feeLevel =
          inputvalue.value !== undefined ? inputvalue.label : "";
      }
      if (fieldName === "effectiveDate") {
        updatedPolicyTypeData[0].effectiveDate =
          inputvalue === "" ? null : new Date(inputvalue).toISOString();
      }
      if (fieldName === "expirationDate") {
        updatedPolicyTypeData[0].expirationDate =
          inputvalue === "" ? null : new Date(inputvalue).toISOString();
      }
    }
  };

  var columns = [
    {
      name: (
        <div>
          Carrier {editMode ? <span className="text-red-500">*</span> : ""}
        </div>
      ),
      width: "10%",
      cell: (row) => {
        return row.editRow ? (
          <div className="w-full">
            <div className="">
              <SelectInput
                options={carrierOptions}
                defaultValue={selectedCarrier}
                isDisabled={true}
                onChange={(e) => {
                  setSelectedCarrier(e);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="flex flex-col text-left align-baseline ">
            <div className="font-bold text-quinary w-full ">
              {row.carrierName}
            </div>
          </div>
        );
      },
      left: true,
      sortable: true,
      grow: 2,
    },
    {
      name: (
        <div>
          State {editMode ? <span className="text-red-500">*</span> : ""}
        </div>
      ),
      cell: (row) => {
        return row.editRow ? (
          <div className="w-full">
            <div className="">
              <SelectInput
                options={stateOptions}
                defaultValue={selectedState}
                isDisabled={true}
                onChange={(e) => {
                  setSelectedState(e);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="w-full ">{row.state}</div>
        );
      },

      sortable: true,
    },
    {
      name: (
        <div>
          Fee Type {editMode ? <span className="text-red-500">*</span> : ""}
        </div>
      ),
      cell: (row) => {
        return row.editRow ? (
          <div className="">
            <div className="w-30 2xl:w-36 2xl:-ml-2">
              <SelectInput
                placeholder="Fee Type"
                options={feeTypeData}
                defaultValue={
                  feeTypeData.filter((x) => x.value === row.feeType).length ===
                  0
                    ? null
                    : feeTypeData.filter((x) => x.value === row.feeType)[0]
                }
                onChange={(e) =>
                  handleEditPolicyType(
                    "EditPolicyType",
                    "feeType",
                    e != null ? e : ""
                  )
                }
              />
            </div>
          </div>
        ) : (
          <div className="w-full">{row.feeType}</div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div>
          Fee Amount {editMode ? <span className="text-red-500">*</span> : ""}
        </div>
      ),
      cell: (row) => {
        return row.editRow ? (
          <div className="w-full">
            <TextInput
              placeholder="Fee Amount"
              defaultValue={parseFloat(row.feeAmount).toFixed(2)}
              onChange={(e) =>
                handleEditPolicyType(
                  "EditPolicyType",
                  "feeAmount",
                  e.target.value
                )
              }
            />
          </div>
        ) : (
          <div className="w-full">
            {"$" + parseFloat(row.feeAmount).toFixed(2)}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Policy Term",
      cell: (row) => {
        return row.editRow ? (
          <div className="">
            <div className="w-30 2xl:w-36 2xl:-ml-2">
              <SelectInput
                options={policyTermOptions}
                defaultValue={selectedPolicyTerm}
                onChange={(e) => {
                  setSelectedPolicyTerm(e);
                  handleEditPolicyType(
                    "EditPolicyType",
                    "policyTerm",
                    e != null ? e : ""
                  );
                  setChanged(true);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="w-full ">{row.policyTerm}</div>
        );
      },
      sortable: true,
    },
    {
      name: "Fee Level",
      left: true,
      cell: (row) => {
        return row.editRow ? (
          <div className="w-full ">
            <SelectInput
              options={feeLevelOptions}
              defaultValue={selectedFeeLevel}
              onChange={(e) => {
                setSelectedFeeLevel(e);
                handleEditPolicyType(
                  "EditPolicyType",
                  "feeLevel",
                  e != null ? e : ""
                );
              }}
            />
          </div>
        ) : (
          <div className="w-full ">{row.feeLevel}</div>
        );
      },
      sortable: true,
    },
    {
      name: (
        <div>
          Effective Date{" "}
          {editMode ? <span className="text-red-500">*</span> : ""}
        </div>
      ),
      cell: (row) => {
        return row.editRow ? (
          <div className="">
            <div className="w-36 2xl:w-38 2xl:-ml-2">
              <DateInput
                defaultValue={
                  row.effectiveDate && row.effectiveDate.slice(0, 10)
                }
                onChange={(e) => {
                  setEffectiveDate(e.target.value);
                  handleEditPolicyType(
                    "EditPolicyType",
                    "effectiveDate",
                    e.target.value
                  );
                  setChanged(true);
                }}
              />
            </div>
          </div>
        ) : (
          <div className="w-full">
            {new Date(row.effectiveDate).toLocaleDateString()}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Expiration Date",
      cell: (row) => {
        return row.editRow ? (
          <div className="">
            <div className="w-28 2xl:w-40 2xl:-ml-1">
              <DateInput
                defaultValue={
                  row.expirationDate && row.expirationDate.slice(0, 10)
                }
                onChange={(e) => {
                  setExpirationDate(e.target.value);
                  handleEditPolicyType(
                    "EditPolicyType",
                    "expirationDate",
                    e.target.value
                  );
                  setChanged(true);
                }}
                min={effectiveDate}
                readOnly={changed && effectiveDate === "" ? true : false}
              />
            </div>
          </div>
        ) : (
          <div className="w-full">
            {new Date(row.expirationDate).toLocaleDateString() === "12/31/1969"
              ? ""
              : new Date(row.expirationDate).toLocaleDateString()}
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "Actions",
      sortable: true,
      cell: (row) =>
        row.editRow ? (
          <div className="flex 2xl:flex-row flex-row gap-x-2 justify-center items-center  ">
            <Button
              className="flex items-center shadow-md text-xs w-4 font-semibold text-white justify-center gap-x-1 rounded-full ml-auto bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70"
              onClickFunction={() => handleEditModal(row)}
            >
              <CheckCircleIcon className="h-4 w-4" />
              <div>Save</div>
            </Button>
            <ButtonCancel
              className="flex items-center text-xs shadow-md font-semibold text-white justify-center gap-x-1 rounded-full bg-red-500 bg-red-500 hover:bg-red-600 px-2 py-1 "
              onClickFunction={() => handlCancel(row)}
            >
              <XCircleIcon className="h-4 w-4" />
              <div>Cancel</div>
            </ButtonCancel>
          </div>
        ) : userPermissions.includes(editPermission) ? (
          <div
            className={
              editMode
                ? "opacity-50 flex justify-center items-center space-x-2 w-full "
                : "opacity-100 flex justify-center items-center space-x-2 w-full"
            }
          >
            <Button
              className={
                selectedRows.length > 0
                  ? "rounded-full space-x-2 items-center bg-quaternary text-white hover:bg-hquaternary opacity-50"
                  : "rounded-full space-x-2 items-center bg-quaternary text-white hover:bg-hquaternary opacity-100"
              }
              disabled={selectedRows.length > 0}
              onClickFunction={() => handleEdit(row)}
            >
              <PencilSquareIcon className="h-4 w-4" />
              <div>Edit</div>
            </Button>
          </div>
        ) : (
          ""
        ),
      center: true,
      button: true,
      grow: 2,
      width: "15%",
    },
  ];

  return (
    <div className="w-full h-full shadow-md overflow-x-auto">
      {userPermissions.includes(viewPermission) ? (
        <div className="text-secondary italic text-xs3  mx-10 ">
          {"" ? (
            <div>
              <p className="font-bold italic inline-block mr-1">Note: </p>Tick
              the box to deactivate some data.
            </div>
          ) : (
            <div></div>
          )}
        </div>
      ) : (
        ""
      )}
      <Table
        title="PolicyFee"
        columns={columns}
        data={!editMode ? policyFeeData : editData}
        selectedRows={selectedRows}
        handleBulkDelete={handleBulkDelete}
        setOpenModal={setOpenModal}
        setIsBulkSelected={setIsBulkSelected}
        selectableRows={!editMode}
        onSelectedRowsChange={handleSelectedRowsChange}
        loading={isLoading}
        clearSelectedRows={clearSelectedRows}
        isDeactive={true}
      />
      <ConfirmBoxModal
        ModalTitle="Save Policy Fee"
        qConfirmation=" Are you sure you want to edit this?"
        isOpen={saveModal}
        onClose={() => setSaveModal(false)}
        onClickFunction={() => handleSave(editDataDetails)}
      />
    </div>
  );
};

export default PolicyFeeTable;
